import { ref, watch } from "vue";
import {
  openByChrome,
  isAndroid,
  isChrome,
  openChromeDownloadPage,
  openInstalledPwa,
  isInFacebook,
  isMobileDevice,
  isIPhone
} from "./utils/pwa";
import { debugStep, showOpenInDefaultTip } from "./global";
import * as Sentry from '@sentry/vue'
import { getUUID } from "./utils/uuid";
const showGiftDialog = ref(false);

const installProgress = ref(0);
// localStorage.removeItem('pwaInstalled');
const deferredPrompt = ref(null);
const pwaInstalled = ref(false);

const showInstallBackTip = ref(false);
watch(debugStep,(newValue)=>{
  // Sentry.captureMessage(`click install  ${getUUID()} :${newValue} ${isAndroid} ${isIPhone()} ${isChrome}`,'info');
});
// localStorage.setItem('installUrl',location.href)
// alert(localStorage.getItem('installUrl'))
function onClickInstall() {

  if (installProgress > 0 && installProgress < 100) {
    debugStep.value = 1;
    //正在安装 不可点击
    console.log("正在安装 不可点击");
    return;
  }
  
  // console.log(`${isAndroid}-${isChrome}-${window.deferredPrompt}-${pwaInstalled.value}-${installProgress.value}`)
  if (isAndroid && isChrome) {
    debugStep.value = 2;
    if (!pwaInstalled.value && window.deferredPrompt) {
      //没安装并且可以安装
      debugStep.value = 3;
      installPwa();
    } else {
      debugStep.value = 4;
      openInstalledPwa();
    }
  } else {
    if(!isMobileDevice()){
      if(window.deferredPrompt){
        installPwa();
      }else {
        openInstalledPwa();
      }
        return;
    } 
    //否则跳转chorme
    debugStep.value = 11;
    showInstallBackTip.value = true;
    setTimeout(() => {
      // alert(1)
      if (isInFacebook()) {
        showOpenInDefaultTip.value = true;
        // alert(12)
      } else {
        listenWindowBeActive();
      }
      // console.log("timeout", showOpenInDefaultTip.value);
      debugStep.value = 12;
      openChromeDownloadPage();
    }, 2000);
    openByChrome();
    // alert('test');
    // window.open('https://installpwa.hanipwa.hanilink.com', '_system');
  } 

 

}
function listenWindowBeActive() {
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") {
    } else if (document.visibilityState === "visible") {
      window.location.reload();
    }
  });
}
window.addEventListener("appinstalled", (event) => {
  // alert('appinstalled')
  debugStep.value = -1
  event.preventDefault();
  // localStorage.setItem("pwaInstalled", '1');
  pwaInstalled.value = true;
  if (installProgress.value >= 100) {
    clearInterval(installProgressTimerId);
  }
});

window.addEventListener("beforeinstallprompt", (event) => {
  // alert('beforeinstallprompt')
  if (window.deferredPrompt) return;
  // Store the installation prompt event so it can be triggered later.
  // alert('beforeinstallprompt')
  event.preventDefault();
  pwaInstalled.value = false;
  // localStorage.removeItem('pwaInstalled');
  window.deferredPrompt = event;
  deferredPrompt.value = event;
});
function installPwa() {
  window.deferredPrompt.prompt();
  // Wait for the user to respond to the prompt
  window.deferredPrompt.userChoice.then((choiceResult) => {
    // alert(choiceResult.outcome)
    // console.log("User accepted");
    if (choiceResult.outcome === "accepted") {
      // alert("User accepted");
      showGiftDialog.value = false;
      startInstallProgress();
    } else {
      window.location.reload();
      console.log("User dismissed");
    }
  });
}
function startInstallProgress() {
  installProgressTimerId = setInterval(() => {
    if (pwaInstalled.value && installProgress.value > 100) {
      installProgress.value = 100;
      clearInterval(installProgressTimerId);
      // window.location.reload();
      return;
    }
    if (installProgress.value >= 98) {
      installProgress.value += 0.1;
    } else if (installProgress.value >= 80) {
      installProgress.value += 1;
    } else {
      installProgress.value += 2;
    }
    // alert(installProgress.value)
  }, 200);
}
var installProgressTimerId = -1;
export {
  onClickInstall,
  showGiftDialog,
  deferredPrompt,
  pwaInstalled,
  installProgress,
  showOpenInDefaultTip,
  showInstallBackTip,
};
